import { render } from "./GirasPage2.vue?vue&type=template&id=75d0aa15&scoped=true"
import script from "./GirasPage2.vue?vue&type=script&lang=js"
export * from "./GirasPage2.vue?vue&type=script&lang=js"

import "./GirasPage2.vue?vue&type=style&index=0&id=75d0aa15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d0aa15"]])

export default __exports__